export default function createEntity (name, tags) {
  return { name, tags }
}
